import classnames from 'classnames';

import { HeroHeadline } from '@components/HeroHeadline';

import { CmsComparisonSection } from '@interfaces/common';

import { ComparisonItem } from './ComparisonItem';
import styles from './ComparisonSection.module.css';

export type ComparisonSectionProps = Omit<
	CmsComparisonSection,
	'_key' | '_type'
>;

export const ComparisonSection: React.VFC<ComparisonSectionProps> = ({
	comparison,
	headline,
}) => {
	return (
		<section>
			<HeroHeadline headingLevel={2} {...headline} />
			<div className={styles.container}>
				<ul className={classnames(styles.comparison, 'stack-inline')}>
					{comparison.map(({ _key, ...comparisonItem }) => (
						<li key={_key}>
							<ComparisonItem {...comparisonItem} />
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};
